var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonIcon01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 13.2339332 0 13.2339332 14 0 14"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jackson-Dashboard-5.0",
    transform: "translate(-488.000000, -2515.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(94.000000, 1973.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(146.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(228.000000, 322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.192802, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.630670848,13.9977153 C0.0759587585,13.9123018 -0.505524712,11.5056605 0.745016408,10.1984959 C1.70719799,9.19275609 2.89580193,9.73496382 3.95009522,8.69870497 C5.09854209,7.56989825 4.12660483,6.49499521 5.20903075,5.29940339 C6.28033975,4.11629662 7.59712869,4.76650991 9.32955467,3.59985169 C11.4599213,2.16526042 11.2859074,-0.0414219755 11.9622251,0.000591196247 C12.8375131,0.054891239 14.0733073,3.81051208 12.420061,5.19952302 C11.1252791,6.28710928 8.90506947,5.21299895 7.84170114,6.39927652 C7.00815831,7.32891703 8.09648301,8.29621086 7.26929271,9.39866027 C6.32775685,10.6535065 4.53725059,9.90658366 2.69093281,11.2981709 C1.09780876,12.4991134 1.08737246,14.0680676 0.630670848,13.9977153",
    id: "Fill-1",
    fill: "#150F44",
    mask: "url(#mask-2)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonIcon01);
export default __webpack_public_path__ + "static/media/carbon_icon01.1b39489d7b5b07b3aa0a643013a8d661.svg";
export { ForwardRef as ReactComponent };